import { noop } from 'motion-utils';
import { createRenderBatcher } from './batcher.mjs';

var _createRenderBatcher = /* @__PURE__ */createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true),
    frame = _createRenderBatcher.schedule,
    cancelFrame = _createRenderBatcher.cancel,
    frameData = _createRenderBatcher.state,
    frameSteps = _createRenderBatcher.steps;

export { cancelFrame, frame, frameData, frameSteps };